import { DropDownList, DropDownListProps } from '@progress/kendo-react-dropdowns';
import * as React from 'react';

type RollsRoyceVehicleDropDownProps = {
  value: string | null;
  onServiceChange: (data: {
    value: string | null;
  }) => void;
} & DropDownListProps;

const RollsRoyceServiceDropDown: React.FC<RollsRoyceVehicleDropDownProps> = ({
  value,
  onServiceChange,
  ...selectProps
}) => {
  //Note modifications to this list must match with the EDI.Core project
  const serviceOptions = [
    "Expedite",
    "Truckload",
    "Milk Run",
    "Air"
  ];

  const defaultItem = 'Select Service Type';

  if (value && !serviceOptions.includes(value)) {
    onServiceChange({ value: null });
  }

  return (
    <DropDownList
      data={serviceOptions}
      value={value || defaultItem}
      defaultValue={defaultItem}
      onChange={(e) => {

        if (e.value !== defaultItem) {
          onServiceChange({
            value: e.value
          });
        } else {
          onServiceChange({
            value: null
          });
        }

        // Call original onChange if provided
        selectProps.onChange?.(e);
      }}
      defaultItem={defaultItem}
      {...selectProps}
    />
  );
};

export default RollsRoyceServiceDropDown;
